import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend'; // For loading translations from a server or local JSON files
import LanguageDetector from 'i18next-browser-languagedetector'; // For detecting user language

i18n
  .use(HttpApi) // Load translations via http
  .use(LanguageDetector) // Detect user's language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'he', // Default language if detection fails
    lng: 'he', // Force Hebrew initially
    debug: true, // Enable debug logs in the console
    supportedLngs: ['en', 'he'],
    ns: [
      'common',
      'login',
      'client',
      'menu',
      'car',
      'inspector',
      'company',
      'employee',
      'report',
      'globalSettings',
    ], // Include 'login' namespace
    interpolation: {
      escapeValue: false, // React already protects against XSS
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to load JSON translation files
    },
  });

export default i18n;
